import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-expense-paid-status',
  templateUrl: './expense-paid-status.component.html',
  styleUrls: ['./expense-paid-status.component.scss'],
  standalone: false
})
export class ExpensePaidStatusComponent {
  @Input() isPaid: boolean = false;
}
